import * as React from 'react';
import { Link } from 'react-router-dom';
import { GroupResource } from '../../../../../../GroupsStore/Types';
import { findLink } from '../../../../../../LinkyLinky';
import { T } from '../../../../../../Translations';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../EmptyFragment';

export interface Props {
  resource: GroupResource;
}

const ManageLink: React.FC<Props> = ({ resource }) =>
  findLink('self', resource.links)
    .map(() => (
      <Link
        to={`/people/groups/${resource.payload.id}`}
        className="px-2 py-1 block w-full cursor-pointer"
      >
        <T kind="Manage Group Members" />
      </Link>
    ))
    .getOrElse(emptyFragment);

export default observer(ManageLink);
